export default "__VITE_ASSET__Cl87gKiX__"